// SettingsAboutPane.jsx

import React from 'react';

// CSS
import './SettingsAboutPane.css';

// Components
import SettingsCoverPane from './SettingsCoverPane';
import SettingsIconPane from './SettingsIconPane';
import SettingsNamePane from './SettingsNamePane';

/**
 * SettingsAboutPane
 *
 * Base identity settings: name, icon, and cover photo.
 *
 * @param {object} theme - Active theme tokens.
 * @param {object|null} base - Active base model.
 * @param {boolean} canEditBase - Whether the user can update base identity.
 *
 * @returns {ReactNode} The rendered about settings pane.
 */
const SettingsAboutPane = React.memo(({
  theme,
  base = null,
  canEditBase = false,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="settings-about-pane-container">

      {/* NAME */}
      <div className="settings-about-pane-section">
        <SettingsNamePane
          theme={theme}
          base={base}
          canEditBase={canEditBase}
        />
      </div>

      {/* ICON */}
      <div className="settings-about-pane-section">
        <SettingsIconPane
          theme={theme}
          base={base}
          canEditIcon={canEditBase}
        />
      </div>

      {/* COVER */}
      <div className="settings-about-pane-section">
        <SettingsCoverPane
          theme={theme}
          base={base}
          canEditCover={canEditBase}
        />
      </div>
    </div>
  );
});

// Dev Tools
SettingsAboutPane.displayName = 'SettingsAboutPane';

export default SettingsAboutPane;
